import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { NavLink, useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import { DecryptOrderFunction, EncryptOrderFun, stackDecrypt } from '../features/CryptoJsService'
import { commonUriAll } from '../CommonUrlList/CommonUrlList'
import { openLoginModal } from '../features/ModalSlice'

export const CommonHeader = () => {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const SessionUser = (sessionStorage.getItem("userData") && (sessionStorage.getItem("userData")))
    const balanceData = useSelector(state => state?.balanceState?.balanceData)

    const dateFormater = (date, separator, day) => {
        var day = date.getDate()
        var month = date.getMonth() + 1;
        var year = date.getFullYear();
        if (day < 10) {
            day = '0' + day;
        }
        if (month < 10) {
            month = '0' + month;
        }
        return year + separator + month + separator + day;
    }

    const timeFormate = (date) => {
        var day = date.getHours()
        var month = date.getMinutes();
        var year = date.getSeconds();
        if (day < 10) {
            day = '0' + day;
        }
        if (month < 10) {
            month = '0' + month;
        }
        return day + ":" + month + ":" + year;
    }

    const makeRandom = (lengthOfCode = Number) => {
        let possible = "1234567890";
        let text = "";
        for (let i = 0; i < lengthOfCode; i++) {
            text += possible.charAt(Math.floor(Math.random() * possible.length));
        }
        return text;
    }

    const [horseData, setHorseData] = useState({
        mid: "",
        eid: "",
        mname: "",
        ename: "",
        countr: 4,
    })

    const onHChange = (e) => {
        setHorseData({
            ...horseData, [e.target.name]: e.target.value
        })
    }

    const numberOFRunners = Array.apply(null, { length: parseInt(horseData.countr) }).map(Number.call, Number)

    const addMasterToDataBase = async (element) => {
        let allrunner = true
        for (let i = 0; i < horseData.countr; i++) {
            let runner = document.getElementById('runner_' + (i)).value
            if (runner === "") {
                allrunner = false
            }
        }
        var date = document.getElementById('new-date').value
        var time = document.getElementById('time-start').value
        var startDate = date + " " + time + ":00.000Z"
        if (!allrunner) {
            toast.error('Please add all runners name')
        } else {
            var randomID = makeRandom(10);
            const addto = []
            const mainObj2 = {
                bettingType: "ODDS", bspMarket: false, canTurnInPlay: true, competitionId: "154896", eventId: horseData.eid, eventTypeId: 14, inplay: true, key: "MARKET:" + "1.5236" + randomID,
                marketId: "1.14" + horseData.eid + randomID, marketName: horseData.mname, marketStatus: 0, marketSuspendTime: new Date(startDate), marketTime: new Date(startDate), marketType: "MATCH_ODDS", numberOfRunners: 0,
                productType: "EXCHANGE", runners: [], totalAvailable: 0, totalMatched: 0, eventName: horseData.ename, competitionName: "IND", eventTypeName: "Horse Racing"
            }
            const mainObject = {
                "btMarketStatus": 0,
                "dtStartDate": startDate,
                // "dtStartDate": new Date(element.marketTime).toLocaleString(),
                "stCompititionID": "154896",
                "stCompititionName": "IND",
                "stEventID": horseData.eid,
                "stEventName": horseData.ename,
                "stMarketID": "1.5236" + randomID,
                "stMarketName": horseData.mname,
                "stSportsID": "14",
                "stSportsName": "Horse Racing",
                "submaster": []
            }
            for (let i = 0; i < horseData.countr; i++) {
                let object = {
                    stInstrumentID: "1.5236" + randomID + "_" + (i + 1),
                    stMarketID: "1.5236" + randomID,
                    stRunnerName: document.getElementById('runner_' + (i)).value,
                    stSelectionID: (i + 1),
                    jockyname: document.getElementById('jocky_' + (i)).value,
                    trainerName: document.getElementById('trainer_' + (i)).value
                }
                let object2 = {
                    selectionId: (i + 1),
                    runnerName: document.getElementById('runner_' + (i)).value,
                    jockyName: document.getElementById('jocky_' + (i)).value,
                    trainerName: document.getElementById('trainer_' + (i)).value
                }
                mainObj2.runners.push(object2)
                mainObject.submaster.push(object)
            }
            const resp = await fetch("https://postg.9xxbet.com/api/v1/master/addmaster", {
                method: "POST",
                headers: {
                    'content-type': 'application/json'
                },
                body: JSON.stringify(mainObj2)
            })
            const respdata = await resp.json()
            const resp2 = await fetch("https://webapi.9xxbet.com/api/v1/master/addmastercobra", {
                method: "POST",
                headers: {
                    'content-type': 'application/json'
                },
                body: JSON.stringify(mainObj2)
            })
            const respdata2 = await resp2.json()
            if (respdata.status === 'success') {
                toast.success("Market added to our server postgrey.")
            } else {
                toast.error(respdata.message)
            }
            addto.push(mainObject)
            // const raw = JSON.stringify(addto);
            // var myHeaders = new Headers();
            // myHeaders.append("Content-Type", "application/json");

            // var requestOptions = {
            //     method: 'POST',
            //     headers: myHeaders,
            //     body: raw,
            //     redirect: 'follow'
            // };

            // fetch("https://masterapi.fun4club.com/api/admin/postmasterhouse", requestOptions)
            //     .then(response => response.json())
            //     .then(result => {
            //         if (result.status) {
            //             toast.success("Market added to our server park.")
            //         } else {
            //             toast.error("Market is not added")
            //         }
            //     })
            //     .catch(error => {
            //         toast.error("Server Error 500")
            //         console.log('error', error)
            //     });
        }
    }

    const openSideBar = () => {
        const sidebarId = document.getElementById("sidebar")
        if (sidebarId.classList.contains("active")) {
            sidebarId.classList.remove("active")
        } else {
            sidebarId.classList.add("active")
        }
        sidebarId.classList.contains("active")
    }

    const logoutUser = async () => {
        localStorage.clear()
        sessionStorage.clear()
        // logOut()
        navigate('/')
        navigate(0)
    }

    return (
        <>
            <header _ngcontent-cts-c46="" class="login-header">
                <app-topnav _ngcontent-cts-c46="" _nghost-cts-c43="">
                    <nav _ngcontent-cts-c43="" class="navbar default-layout-navbar justify-content-between col-lg-12 col-12 p-0 d-flex flex-row">
                        <div _ngcontent-cts-c43="" class="text-center navbar-brand-wrapper d-flex align-items-center justify-content-center">
                            <button id='sidebar-btn' onClick={() => { openSideBar() }} style={{ color: "white" }} _ngcontent-gdi-c43="" type="button" data-toggle="minimize" class="navbar-toggler navbar-toggler align-self-center d-lg-none">
                                <span _ngcontent-gdi-c43="" class="fa fa-navicon"></span>
                            </button>
                            <a style={{ color: "white", display: 'contents' }} _ngcontent-cts-c43="" onClick={() => { navigate("/") }} class="navbar-brand brand-logo">
                                {/* <span>FUN  </span>  <h1> 4 </h1> <span>CLUB</span> */}
                                <span>Horse</span>
                            </a>
                        </div>
                        <div _ngcontent-cts-c43="" class="navbar-menu-wrapper d-flex align-items-stretch">

                            <div _ngcontent-cts-c43="" class="search-field d-none">
                                <form _ngcontent-cts-c43="" novalidate="" action="#" class="d-flex align-items-center h-100 ng-untouched ng-pristine ng-valid">
                                    <div _ngcontent-cts-c43="" class="input-group">
                                        <div _ngcontent-cts-c43="" class="input-group-prepend bg-transparent">
                                            <i _ngcontent-cts-c43="" class="input-group-text border-0 mdi mdi-magnify"></i>
                                        </div>
                                        <input _ngcontent-cts-c43="" type="text" placeholder="Search projects" class="form-control bg-transparent border-0" />
                                    </div>
                                </form>
                            </div>
                            {
                                SessionUser !== null && SessionUser ? (
                                    <div className='m-2' _ngcontent-iqs-c22="">
                                        <div _ngcontent-iqs-c22="" class="d-flex gap-1">
                                            <div _ngcontent-iqs-c22="" class="dropdown">
                                                <a _ngcontent-iqs-c22="" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="true" class="btn btn-login dropdown-toggle">
                                                    <i _ngcontent-iqs-c22="" class="fa-solid fa-user"></i>
                                                    <span _ngcontent-iqs-c22="" class="ps-1 d-lg-inline d-none">{SessionUser.UserName}</span>
                                                </a>
                                                <ul _ngcontent-iqs-c22="" id='dropdown' class="dropdown-menu dropdown-menu-end" data-bs-popper="static">
                                                    <li _ngcontent-iqs-c22="" class="text-center border-bottom fw-semibold">
                                                        <i _ngcontent-iqs-c22="" class="fa-solid fa-user"></i>
                                                        <span _ngcontent-iqs-c22="" class="ps-1 d-lg-inline">{SessionUser.UserName}</span>
                                                    </li>
                                                    <li _ngcontent-iqs-c22="">
                                                        <a class="dropdown-item a" data-bs-toggle="modal" data-bs-target="#Horse-Market">Add Horse Market</a>
                                                    </li>
                                                    <li _ngcontent-iqs-c22="" class="px-1 mt-3">
                                                        <button _ngcontent-iqs-c22="" class="btn w-100 btn-login" onClick={logoutUser} fdprocessedid="x3fp1">Logout</button>
                                                    </li>
                                                </ul>
                                            </div>
                                            <div _ngcontent-iqs-c22="" class="dropdown">
                                                <a _ngcontent-iqs-c22="" href="javascript:void(0)" role="button" data-bs-toggle="dropdown" aria-expanded="false" class="balance btn btn-login dropdown-toggle">
                                                    <i _ngcontent-iqs-c22="" class="fa-solid fa-coins"></i> {parseFloat(balanceData?.deBalance).toFixed(2)} </a>
                                                <ul _ngcontent-iqs-c22="" class="dropdown-menu dropdown-menu-end">
                                                    {/* <li _ngcontent-iqs-c22="">
                                                        <a _ngcontent-iqs-c22="" href="javascript:void(0)" class="dropdown-item text-center fw-semibold">
                                                            <i _ngcontent-iqs-c22="" class="fa fa-university"></i> Balance Information </a>
                                                    </li>
                                                    <li _ngcontent-iqs-c22="">
                                                        <a _ngcontent-iqs-c22="" href="javascript:void(0)" class="dropdown-item">Available Chips: {parseFloat(balanceData?.deBalance).toFixed(2)}</a>
                                                    </li>
                                                    <li _ngcontent-iqs-c22="">
                                                        <a _ngcontent-iqs-c22="" href="javascript:void(0)" class="dropdown-item">Available Credit Chips: {parseFloat(balanceData?.deCreditChips).toFixed(2)}</a>
                                                    </li>
                                                    <li _ngcontent-iqs-c22="">
                                                        <a _ngcontent-iqs-c22="" href="javascript:void(0)" class={parseFloat(balanceData?.deBalance - balanceData?.deCreditChips).toFixed(2) > 0 ? "dropdown-item text-success" : "dropdown-item exp-c"}>Winning Amount: {parseFloat(Math.abs(balanceData?.deBalance - balanceData?.deCreditChips)).toFixed(2)}</a>
                                                    </li>
                                                    <li _ngcontent-iqs-c22="">
                                                        <a _ngcontent-iqs-c22="" data-bs-toggle="modal" data-bs-target="#exposurePopup" class="dropdown-item exp-c">Exposure: {parseFloat(balanceData?.deLiability + balanceData?.deRisk).toFixed(2)}</a>
                                                    </li> */}
                                                </ul>
                                            </div>
                                        </div>
                                        <div _ngcontent-iqs-c22="" class="text-end small">
                                            <a style={{ color: "white" }} _ngcontent-iqs-c22="" data-bs-toggle="modal" data-bs-target="#exposurePopup">
                                                <span style={{ padding: "0 2px" }}>{SessionUser.UserName}</span>
                                            </a>
                                        </div>
                                    </div>
                                ) : (
                                    <ul style={{ marginRight: "10px" }} _ngcontent-cts-c43="" class="navbar-nav navbar-nav-right sign-in-nav">
                                        <li _ngcontent-cts-c43="" class="nav-item">
                                            <button onClick={() => {
                                                dispatch(openLoginModal())
                                            }} _ngcontent-cts-c43="" class="btn btn-block btn-gradient-primary btn-sm font-weight-medium auth-form-btn btn-login">sign in</button>
                                        </li>
                                    </ul>
                                )
                            }
                        </div>
                    </nav>
                </app-topnav>
            </header>
            <div _ngcontent-tpi-c33="" id="Horse-Market" class="modal fade " aria-modal="true" role="dialog" style={{ display: "none" }}>
                <div _ngcontent-tpi-c33="" class="modal-dialog">
                    <div _ngcontent-tpi-c33="" class="modal-content">
                        <div _ngcontent-tpi-c33="" class="modal-header text-dark">
                            <h1 _ngcontent-tpi-c33="" id="book-deal-popupLabel" class="modal-title fs-5 text-uppercase">Add Horse Market bellow</h1>
                            <button _ngcontent-tpi-c33="" type="button" data-bs-dismiss="modal" aria-label="Close" class="btn-close"></button>
                        </div>
                        <div _ngcontent-tpi-c33="" class="modal-body d-flex flex-column">
                            <form>
                                <div>
                                    <label htmlFor="">EventID</label>
                                    <input className='form-control' placeholder='EventID' type="text" onChange={onHChange} value={horseData.eid} name='eid' />
                                </div>
                                <div>
                                    <label htmlFor="">Event Name</label>
                                    <input className='form-control' placeholder='Event Name' type="text" onChange={onHChange} value={horseData.ename} name='ename' />
                                </div>
                                {/* <div>
                                    <label htmlFor="">MarketID</label>
                                    <input className='form-control' placeholder='MarketID' type="text" onChange={onHChange} value={horseData.mid} name='mid' />
                                </div> */}
                                <div>
                                    <label htmlFor="">MarketName</label>
                                    <select className='input-group' onChange={onHChange} name="mname" id="">
                                        <option value="">Select From below</option>
                                        <option value="Match Odds">Match Odds</option>
                                        <option value="JODI">JODI</option>
                                        <option value="TRIO">TRIO</option>
                                        <option value="COMBO">COMBO</option>
                                    </select>
                                    <input className='form-control' placeholder='MaketName' type="text" onChange={onHChange} value={horseData.mname} name='mname' />
                                </div>
                                <div>
                                    <label htmlFor="">Give number of runners</label>
                                    <input className='form-control' placeholder='Enter runner number' type="text" onChange={onHChange} value={horseData.countr} name='countr' />
                                </div>
                                <div>
                                    <label htmlFor="">Enter Starting Time</label>
                                    <input id='new-date' type="date" className="form-control rounded-0 text-uppercase ng-untouched ng-pristine ng-valid" />
                                    <div class="cs-form">
                                        <input type="time" id='time-start' className='form-control' />
                                    </div>
                                </div>
                                {
                                    numberOFRunners.map((a, i) => (
                                        <div>
                                            <label htmlFor="">Selection {i + 1}</label>
                                            <div className='d-flex gap-2'>
                                                <input className='form-control' placeholder='Enter Runner name here' id={'runner_' + i} type="text" name='sel1' />
                                                <input className='form-control' placeholder='Enter Jocky name here' id={'jocky_' + i} type="text" name='sel1' />
                                                <input className='form-control' placeholder='Enter Trainer name here' id={'trainer_' + i} type="text" name='sel1' />
                                            </div>
                                        </div>
                                    ))
                                }
                            </form>
                            <button onClick={() => {
                                addMasterToDataBase()
                                // addTossMarket(homeMaster.filter(a => a.stMarketName === "Match Odds")[0])
                            }} className='btn btn-success btn-lg'>Add</button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
